import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

export function NavItem({ nav, onNavigate }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(nav.path, { replace: true });
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <ListItem selected={nav.path === location.pathname} button key={nav.name} onClick={handleNavigate}>
      <ListItemIcon>{nav.icon}</ListItemIcon>
      <ListItemText primary={nav.title} />
    </ListItem>
  );
}
